export enum KeyboardKey {
  ArrowDown = 'ArrowDown',
  ArrowUp = 'ArrowUp',
  Backspace = 'Backspace',
  Enter = 'Enter',
  Escape = 'Escape',
  Spacebar = ' ',
  Tab = 'Tab',
}
